export default __webpack_public_path__ + "static/media/bunker_logo.603099e9.png";